import React, { Suspense } from 'react';
import { Spin } from 'antd';
import { Routes, Route } from 'react-router-dom';
// import { useSelector } from 'react-redux';

import DataMiningPortal from './datamining';
import VASPortal from './vas';
import ExchangePortal from './exchange';
import FinancePortal from './finance';
import RankingPortal from './ranking';
import DiscountPortal from './discount';
import EmployeeDiscountPortal from './employeeDiscount';
import QR from './qr';
import SPLPortal from './spl';
import MarketingPortal from './marketing';

const  ASMRoutes = () => {

    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Routes>
                <Route path="/mining/*" element={<DataMiningPortal />} />
                <Route path="/exchange/*" element={<ExchangePortal />} />
                <Route path="/finance/*" element={<FinancePortal />} />
                <Route path="/manager/*" element={<DiscountPortal />} />
                <Route path="/employee_discount/*" element={<EmployeeDiscountPortal />} />
                <Route path="/vas/*" element={<VASPortal />} />
                <Route path="/ranking/*" element={<RankingPortal />} />
                <Route path="/qr/*" element={<QR />} />
                <Route path="/spl/*" element={<SPLPortal />} />
                <Route path="/marketing/*" element={<MarketingPortal />} />
                <Route path="/store_panel_content" element={<></>} />
            </Routes>
        </Suspense>
    );

}

export default ASMRoutes;
